export default {"src":"/_next/static/media/ox.7e6b9d94.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};